<template>
    <b-container fluid class="my-4">
      <b-row>
        <b-col cols="12" md="8" lg="6" class="mx-auto">
          <b-card title="Crear Cirugia Clinico">
            <validation-observer v-slot="{ invalid }" ref="observer">
              <b-form @submit.prevent="submitForm">
                
                <b-form-group  label-for="codigo">
                  <label>Código: <span class="text-danger">*</span></label>
                  <validation-provider #default="{ errors }" name="codigo" rules="required">
                    <b-form-input id="codigo" :state="errors.length > 0 ? false : null" v-model="cirugia.codigo"
                      type="text" ></b-form-input>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                
                <b-form-group >
                  <label>Nombre: <span class="text-danger">*</span></label>
                  <validation-provider #default="{ errors }" name="nombre" rules="required">
                    <b-form-input id="nombre" :state="errors.length > 0 ? false : null" v-model="cirugia.nombre"
                      type="text" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>



                <b-form-group  label-for="preciodoc">
                  <label>Precio Doctor: <span class="text-danger">*</span></label>
                  <validation-provider #default="{ errors }" name="preciodoc" rules="required">
                    <b-form-input id="preciodoc" :state="errors.length > 0 ? false : null" v-model="cirugia.preciodoc"
                      type="number" onkeypress="return (event.charCode >= 48 && event.charCode <= 57)"></b-form-input>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <b-form-group  label-for="precioan">
                  <label>Precio Anestesiologo: <span class="text-danger">*</span></label>
                  <validation-provider #default="{ errors }" name="precioan" rules="required">
                    <b-form-input id="precioan" :state="errors.length > 0 ? false : null" v-model="cirugia.precioan"
                      type="number" onkeypress="return (event.charCode >= 48 && event.charCode <= 57)"></b-form-input>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                
                
                <b-form-group label-for="establecimiento">
                  <label>Establecimiento: <span class="text-danger">*</span></label>
                  <validation-provider #default="{ errors }" name="establecimiento" rules="required">
                    <v-select id="establecimiento" v-model="cirugia.establecimiento"
                      placeholder="Buscar por establecimiento." :options="establecimientos" :reduce="option => option.value"
                      label="text" class="d-inline-block w-100" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <b-form-group label-for="especialidad">
                  <label>Especialidad: <span class="text-danger">*</span></label>
                  <validation-provider #default="{ errors }" name="especialidad" rules="required">
                    <v-select id="especialidad" v-model="cirugia.especialidad"
                      placeholder="Buscar por especialidad." :options="especialidades" :reduce="option => option.value"
                      label="text" class="d-inline-block w-100" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                
                <b-form-group label="Estado:" label-for="estado-switch">
                  <b-form-checkbox id="estado-switch" v-model="cirugia.estado" value="1" unchecked-value="0" switch
                    disabled>
                  </b-form-checkbox>
                </b-form-group>

                <b-button type="submit" variant="primary" :disabled="invalid">Crear Cirugia</b-button>

              </b-form>
            </validation-observer>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </template>
  
  <script>
  import axios from 'axios';
  import rutas from '@/assets/utils/rutas.json';
  import vSelect from 'vue-select'
  import { ValidationObserver, ValidationProvider } from 'vee-validate'
  import { BContainer, BRow, BCol, BCard, BForm, BFormGroup, BFormInput, BButton, BFormCheckbox } from 'bootstrap-vue';
  
  export default {
    components: {
      BContainer,
      BRow,
      BCol,
      BCard,
      BForm,
      BFormGroup,
      BFormInput,
      BButton,
      BFormCheckbox,
      ValidationProvider,
      ValidationObserver,
      vSelect,
    },
    data() {
      return {
        cirugia: {
          id: '',
          nombre: '',
          preciodoc: 0,
          precioan: 0,
          codigo: '',
          estado: '1',
                 
          
          establecimiento: '',
          especialidad : ''
    
          
          
          
        },
      };
    },
    created() {// aqui se colocan las funciones que aparezcan cargadas cuando se haga un post o un f5 de la misma.
      const idCirugia = this.$route.params.id;
      console.log(idCirugia);
      this.fetchEstablecimientos();
      this.fetchEspecialidades();
      this.comprobarPermisos();
  
    },
    methods: {
      comprobarPermisos() {
      if (localStorage.getItem('permisos').indexOf('crear_cirugia') === -1) {
        this.$router.push({ name: 'not-permitted' })
      }
    },
      async fetchEstablecimientos() {
        const query = `
                          query {
                              allEstablecimientos {
                                  id
                                  Descripcion
                                  uniCodigo
                              }
                          }
                      `;
        try {
          const response = await axios.post(rutas.axios + 'api', { query });
          this.establecimientos = response.data.data.allEstablecimientos.map(item => ({
            value: item.id,
            text: item.Descripcion,
            uniCodigo: item.uniCodigo
          }));
        } catch (error) {
          console.error('An error occurred while fetching the options:', error);
        }
      },
      async fetchEspecialidades() {
            const query = `
                        query {
                            allEspecialidades {
                                id
                                descripcion
                            }
                        }
                    `;
            try {
                const response = await axios.post(rutas.axios + 'api', { query });
                this.especialidades = response.data.data.allEspecialidades.map(item => ({
                    value: item.id,
                    text: item.descripcion
                }));
            } catch (error) {
                console.error('An error occurred while fetching the options:', error);
            }
        },
//       async fetchTipoTerapias() {
//         const query = `
//         query {
//   allTerapias {
//     terapias {
//       tipoTerapia {
//         id
//         descripcion
        
        
//       }
      
//     }
//   }
// }

//                       `;
//         try {
//           const response = await axios.post(rutas.axios + 'api', { query });
//           this.tipoTerapias = response.data.data.allTerapias.terapias.map(item => ({
//             value: item.tipoTerapia.id,
//             text: item.tipoTerapia.descripcion,
            
//           }));
//         } catch (error) {
//           console.error('An error occurred while fetching the options:', error);
//         }
//       },


      async submitForm() {
        console.log(this.cirugia)
        // const precioNetoFormateado = parseFloat(this.cirugia.precioNeto).toFixed(4);
        
        // console.log(precioNetoFormateado)
        const precioDocFormateado = parseFloat(this.cirugia.preciodoc);
        const precioAnFormateado = parseFloat(this.cirugia.precioan);
        const query = `
        mutation crearcirugiasmedicas($cirugiasMedicasCreados: [CirugiaMedicaInput!]!) {
  crearcirugiasmedicas(cirugiasMedicas: $cirugiasMedicasCreados) {
    cirugiasMedicasCreados{
      token
      id
      
    }
    status
    message
  }
}
             `;
  
        const variables = {
          cirugiasMedicasCreados: {
            
            
            codigo: this.cirugia.codigo,
            nombre: this.cirugia.nombre,                     
            precioDoctor: precioDocFormateado,
            precioAnestesiologo: precioAnFormateado,
            estado: this.cirugia.estado,
            establecimiento: this.cirugia.establecimiento,
            especialidad: this.cirugia.especialidad
  
          }
        };
        console.log(variables)
  
        try {
          // Realizar la solicitud GraphQL utilizando axios
          const response = await axios.post(rutas.axios + 'api', {
            query: query,
            variables: variables
          });
          console.log("imprimir response", response.data.data.crearcirugiasmedicas)
  
          // Verificar si la operación fue exitosa
          if (response.data.data.crearcirugiasmedicas.status === "success") {
            // Mostrar una alerta de éxito
            await this.$swal({
              icon: 'success',
              title: 'Éxito',
              text: 'La cirugia se creo correctamente.'
            });
  
  
  
            // Redirigir a otra página si es necesario
  
  
  
            this.$router.push({ name: 'consultar_cartera_cirugia' });
  
            // Limpiar el formulario o realizar otras acciones necesarias
            // this.medicamento = { ... };
  
          } else {
            // Manejar el caso de error
            this.$swal({
                  title: 'Error',
                  text: response.data.data.crearAdmision.message,
                  icon: 'error',
                  confirmButtonColor: '#089599',
                });
          }
  
  
        } catch (error) {
          // Mostrar una alerta de error si la solicitud falla
          await this.$swal({
            icon: 'error',
            title: 'Error',
            text: error.message || 'Hubo un problema al crear la cirugia.'
          });
        }
      },
  
  
    }
  };
  </script>
   